import triggerToast from "./notifications";

const handleNewApiError = (error) => {
  let errorText = "";
  console.log(error, "error");
  console.error("API Error:", error);

  if (error && error.message) {
    errorText = error.message;
    console.error("Error message:", error.message);
  }
  if (error && error.response && error.response.message) {
    errorText = error.response.message;
    console.error("Response message:", error.response.message);
  }
  if (error && error.response && error.response.data) {
    if (error.response.data.message) {
      errorText = error.response.data.message;
      console.error("Response data message:", error.response.data.message);
    } else if (error.response.data.msg) {
      errorText = error.response.data.msg;
      console.error("Response data msg:", error.response.data.msg);
    } else if (error.response?.data?.error?.message) {
      errorText = error.response.data.error.message;
      console.error("Response data error message:", error.response.data.error.message);
    } else if (error.response.data.error) {
      errorText = error.response.data.error;
      console.error("Response data error:", error.response.data.error);
    } else {
      errorText = error.response.data;
      console.error("Response data:", error.response.data);
    }
  }
  const finalErrortext =  errorText?.length ? errorText : "Oops! Something went wrong";
  triggerToast(finalErrortext, "error");
};

export default handleNewApiError;
